<template lang="pug">
	b-card
		b-card-title Программа
		hr
		b-row
			b-col(cols="12" md="4" lg="3" v-if="categoryTypes.data.length!==0")
				filterComponent

			b-col(cols="12" :md="categoryTypes.data.length!==0?8:12"  :lg="categoryTypes.data.length!==0?9:12")
				sessionsBlock
</template>

<script>
	import { mapActions, mapState } from 'vuex'

	// Vue components
	import filterComponent from './filterComponent'
	import sessionsBlock from './sessions-block'


	export default {
		name: 'Sessions-Block',
		components: {
			filterComponent,
			sessionsBlock,
		},
		mixins: [],
		data: () => ({

		}),
		computed: {
			...mapState({
				categoryTypes: state=>state.event.categoryTypes,
			}),
		},
		methods: {
			...mapActions('event/nested/categoryTypes', ['getEventCategoryTypes']),
		},
		beforeMount(){
			this.$store.dispatch('getEventCategoryTypes', { id:this.$route.params.id });
		},
	}
</script>
